import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';

import { PermissionAliasEnum } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-no-data-to-display',
    templateUrl: './no-data-to-display.component.html',
})
export class NoDataToDisplayComponent {
    public readonly displayedMessage = input<string>('noProjectDataToDisplay');
    public readonly iconSize = input<SizeProp>('3x');
    public readonly information = input<string | undefined>();
    public readonly textWidth = input<string>('w-full');

    protected readonly PermissionAliasEnum = PermissionAliasEnum;
    protected readonly textSize = computed<string>(() => {
        switch (this.iconSize()) {
            case '1x':
                return 'text-sm font-normal';
            case '2x':
                return 'text-lg';
            case '3x':
                return 'text-xl';
            case '4x':
                return 'text-2xl';
            default:
                return 'text-3xl';
        }
    });
}
